<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link :to="{ path: '/message-template' }" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.CreateMessageTemplate") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.MessageType") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.MessageType')"
                >
                  <v-select
                    label="value"
                    :options="ReportsData.messageTypes"
                    v-model="Reports.messageType"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(value) => value.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.TemplateDescription')"
              >
                <vs-input
                  :label="$t('setup.label.TemplateDescription')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.templateDescription"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full mb-4"
            >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="`${$t('customers.label.category')} ${$t(
                  'customers.label.id'
                )}`"
              >
                <vs-input
                  :label="`${$t('customers.label.category')} ${$t(
                    'customers.label.id'
                  )}`"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.evrCategory"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full mb-4"
            >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('customers.label.event_id')"
              >
                <vs-input
                  :label="$t('customers.label.event_id')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.evrEvent"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full mb-4">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Header')"
              >
                <vs-input
                  :label="$t('setup.label.Header')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.header"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full mb-4"
            >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Footer')"
              >
                <vs-input
                  :label="$t('setup.label.Footer')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.footer"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Subject')"
              >
                <vs-input
                  :label="$t('setup.label.Subject')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.subject"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div
              class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
              v-if="Reports.messageType === 'E'"
            >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Header')"
              >
                <vs-input
                  :label="$t('setup.label.Header')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.header"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div
              class="vx-col w-full mt-5 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
              v-if="Reports.messageType === 'E'"
            >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Footer')"
              >
                <vs-input
                  :label="$t('setup.label.Footer')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.footer"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div
              :class="[
                'vx-col',
                'w-full',
                'lg:w-1/2',
                'md:w-1/2',
                'sm:w-full',
                'xs:w-full',
                { 'mt-5': Reports.messageType === 'E' },
              ]"
            >
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">
                  {{ $t("setup.label.Body") }}<span class="required"> *</span>
                </small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Body')"
                >
                  <vs-textarea
                    class="w-full mb-2 font-semibold"
                    v-model="Reports.body"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <h4>{{ $t("setup.label.MessageParams") }}</h4>
            </div>
          </div>
          <div class="vx-row">
            <div
              class="vx-col w-full mt-5 lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
            >
              <vs-input
                :label="$t('setup.label.Parameter')"
                class="w-full mb-2 font-semibold"
                v-model="Reports.parameter"
              />
            </div>
            <div class="vx-col md:w-1/4 mt-8" style="margin: 0.5rem 0">
              <vs-button
                @click="addParameter"
                icon-pack="feather"
                icon="icon-plus"
                :disabled="!Reports.parameter"
                :title="$t('system.label.Add')"
                color="success"
                svgClasses="w-5 h-5
              hover:text-primary stroke-current cursor"
              >
              </vs-button>
            </div>
          </div>
          <div class="vx-row mt-6">
            <div class="vx-row w-full ml-2">
              <div class="vx-col md:w-1/2">
                <b>{{ $t("setup.label.Params") }}</b>
              </div>
            </div>

            <div
              class="vx-row w-full ml-2"
              v-for="(Reports, index) in Reports.messageParams"
              :key="index"
            >
              <div class="vx-col md:w-1/2">
                <vs-input
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.parameter"
                />
              </div>
              <div class="vx-col mt-2 md:w-1/2">
                <button
                  @click="removeItem(index)"
                  class="bGNone mt-4 border-none view_editTable_btn cursor"
                >
                  <feather-icon
                    icon="TrashIcon"
                    :title="$t('system.label.Delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    class="icon_row"
                  />
                </button>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createmessages"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const ReportsEmptyObj = {
  body: "",
  footer: "",
  header: "",
  messageType: "",
  subject: "",
  templateDescription: "",
  evrCategory: "",
  evrEvent: "",
  messageParams: [],
};

export default {
  data() {
    return {
      Reports: ReportsEmptyObj,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      ReportsData: (state) => state.messageTemplate.ListViewMessagesTemplate,
    }),
    breadcrumbs() {
      return [
        {
          name: this.$t("admin.label.Message Template"),
          to: "/message-template/",
        },
        { name: this.$t("setup.label.CreateMessageTemplate"), to: "/" },
      ];
    },
  },
  methods: {
    removeItem(i) {
      this.Reports.messageParams.splice(i, 1);
    },
    addParameter() {
      try {
        let crateParameter = {
          parameter: this.Reports.parameter,
        };
        if (this.Reports.parameter !== "") {
          this.Reports.messageParams = [
            ...this.Reports.messageParams,
            crateParameter,
          ];
          this.Reports.parameter = "";
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createmessages() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      if (this.Reports.messageParams.length == 0) {
        this.warningPopup = true;
        this.warningText = "Please add message params";
        return;
      }
      try {
        delete this.Reports.parameter;
        await this.$store.dispatch(
          "messageTemplate/createmessagesAction",
          this.Reports
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Message Template Created Successfully!",
          type: "success",
        });
        this.$router.push("/message-template");
        this.resetForm();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async getMessagesTemplate() {
      try {
        await this.$store.dispatch(
          "messageTemplate/setMessagesTemplate",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    cancel() {
      this.$router.push("/message-template");
    },

    resetForm() {
      this.Reports = ReportsEmptyObj;
      this.Reports.messageType = "";
      this.Reports.templateDescription = "";
      this.Reports.subject = "";
      this.Reports.evrCategory = "";
      this.Reports.evrEvent = "";
      this.Reports.header = "";
      this.Reports.footer = "";
      this.Reports.body = "";
      this.Reports.messageParams = [];
    },
  },
  watch: {},
  created() {},
  mounted() {
    this.resetForm();
    this.id = this.$route.params.id;
    this.getMessagesTemplate();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
